import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import SalesCatalystSectionBottom from '../SalesCatalystSectionBottom';
import BarChart from '../../common/BarChart';

import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import { numberWithCommas, getFiltersForGivenFamilyId } from '../../../util/CommonUtils';

import { SALES_CATALYST_OVERLAP_SUBENTITY_CHART_HEADER, NO_DATA_AVAILABLE_MSG } from '../../../messages/messages';
import { getColorCodeForGivenCategory, createSubCategoryArray } from '../../../util/SalesCatalystUtils';
import { SC_MEDIA_REPORT,
  DISPLAY_SUB_ENTITY_CHART_COUNT,
  SC_SUB_ENTITY_REPORT,
} from '../../../constants';
import filterIconActive from '../../../images/insight360/filter-icon_active.png';
import FilterSearchComponent from '../../common/FilterSearchComponent';
import clearIcon from '../../../images/insight360/clear-field-icon_190-190-190.png';

class SalesCatalystSubEntityBarChart extends React.Component {
  constructor(props) {
    super(props);
    const subCategories = this.props.selectedFilters !== undefined
          ? getFiltersForGivenFamilyId(this.props.selectedFilters, this.props.studyFamilyId)
          : [];
    this.state = {
      displayBarChartCount: DISPLAY_SUB_ENTITY_CHART_COUNT,
      showFilterSearch: false,
      subCategories,
      selectedFilter: this.props.selectedFilters !== undefined
      ? this.props.selectedFilters
      : [],
    };
  }

  componentDidMount() {
    const { targetOnScreen, graphData, getSubEntityBarChartData, selectedFilters, studyFamilyId } = this.props;

    if (targetOnScreen && _.isEmpty(graphData.scSubEntity)) {
      const subCategories = createSubCategoryArray(
        getFiltersForGivenFamilyId(selectedFilters, studyFamilyId));
      getSubEntityBarChartData(SC_MEDIA_REPORT,
        undefined, undefined, undefined, subCategories);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { targetOnScreen, getSubEntityBarChartData, dataSelection, selectedFilters } = this.props;
    if (!targetOnScreen && nextProps.targetOnScreen && dataSelection.targetMarket.length > 0 &&
       dataSelection.entity.length > 0) {
      const subCategoriesList = createSubCategoryArray(
        getFiltersForGivenFamilyId(nextProps.selectedFilters, nextProps.studyFamilyId));
      getSubEntityBarChartData(SC_MEDIA_REPORT,
        undefined, undefined, undefined, subCategoriesList);
      this.setState({
        displayBarChartCount: DISPLAY_SUB_ENTITY_CHART_COUNT,
      });
    }
    if (selectedFilters !== nextProps.selectedFilters) {
      const subCategories = getFiltersForGivenFamilyId(nextProps.selectedFilters,
        nextProps.studyFamilyId);
      this.setState({
        selectedFilter: nextProps.selectedFilters,
        subCategories,
      });
    }
  }

  getColorCode = overlapPercentage => {
    const subEntity = getColorCodeForGivenCategory('SUBENTITY');
    const subEntityOverlap = getColorCodeForGivenCategory('SUBENTITYOVERLAP');
    const color = `${`linear-gradient(to right,${subEntityOverlap}0%,${subEntityOverlap}${overlapPercentage.toString()
      }, ${subEntity} 0%, ${subEntity} 100%)`}`;
    return color;
  }

  increaseDisplayBarChartCount = () => {
    this.setState({
      displayBarChartCount: this.state.displayBarChartCount + DISPLAY_SUB_ENTITY_CHART_COUNT,
    });
  }

  findBarWidth = (highestWeighted, currentWeight) => {
    let widthPercentage = 0;
    widthPercentage = Math.round((currentWeight * 100) / highestWeighted);
    if (widthPercentage < 16) {
      widthPercentage = 17;
    }
    return widthPercentage;
  }

  findWeightedLeftPadding = (highestWeighted, currentWeight) => {
    const widthPercentage = this.findBarWidth(highestWeighted, currentWeight);
    let leftPadding = 0;

    if (widthPercentage <= 20) {
      leftPadding = widthPercentage + 2;
      return leftPadding;
    }

    if (widthPercentage <= 30) {
      leftPadding = widthPercentage + 1.5;
      return leftPadding;
    }

    if (widthPercentage < 60) {
      leftPadding = widthPercentage + 1;
      return leftPadding;
    }
    return leftPadding;
  }

  replaceOverlapSubEntityChartHeader = () => {
    let headerName = SALES_CATALYST_OVERLAP_SUBENTITY_CHART_HEADER;
    let entityName = '';
    if (!_.isEmpty(this.props.graphData.scSubEntity)) {
      entityName = this.props.graphData.scSubEntity.label;
      headerName = _.replace(headerName, 'ENTITYNAME', entityName);
    }
    return headerName;
  }

  closeFilterBox = () => {
    this.setState({
      showFilterSearch: false,
    });
  };

  searchFilterFn = (searchVal, callback) => {
    this.props.getfilterSearchResult(
      this.props.componentInfo.category,
      searchVal,
      callback,
    );
  };

  applyFilterFn = filters => {
    const { saveSelectedFilters, getSubEntityBarChartData, componentInfo } = this.props;
    this.setState({
      showFilterSearch: false,
    });
    if (filters !== '') {
      const subCategories = createSubCategoryArray(filters);
      const modifiedFilters = this.updateFiltersList(filters);
      saveSelectedFilters(modifiedFilters, componentInfo.category);
      getSubEntityBarChartData(SC_MEDIA_REPORT,
        undefined, undefined, undefined, subCategories);
    }
  };

  updateFiltersList = filters => {
    const { studyFamilyId, selectedFilters } = this.props;

    let modifiedFilters = [];
    if (selectedFilters !== undefined && _.isArray(selectedFilters) && selectedFilters.length > 0) {
      const filter = selectedFilters[0];
      if (filter.studyFamilyId !== undefined) {
        modifiedFilters = _.cloneDeep(selectedFilters);
      }
    }
    const index = _.findIndex(modifiedFilters, { studyFamilyId });
    if (index >= 0) {
      modifiedFilters[index] = { studyFamilyId, filters };
    } else {
      modifiedFilters.push({ studyFamilyId, filters });
    }
    return modifiedFilters;
  }

  removeFilterFn = filterVal => {
    const { subCategories } = this.state;
    const selFilters = _.cloneDeep(subCategories);
    const itemIndex = _.findIndex(selFilters, { value: filterVal });
    selFilters.splice(itemIndex, 1);
    this.applyFilterFn(selFilters);
  };

  getToolTip = data => {
    return (
      <span
        style={{
          whiteSpace: 'nowrap',
          border: 'black',
          fontSize: '11px',
          color: 'black',
          textAlign: 'left',
          alignSelf: 'stretch',
          display: 'block',
        }}
      >
        SAMPLE: <b>{numberWithCommas(Math.round(data.details[0].sample))}</b><br />
        WEIGHTED: <b>{numberWithCommas(Math.round(data.details[0].weighted))}</b><br />
        INDEX: <b>{numberWithCommas(Math.round(data.details[0].index))}</b>
      </span>
    );
  }
  render() {
    const { subEntities, graphData, title, highestWeighted } = this.props;
    return (
      (graphData.scSubEntity.groups !== undefined) && <div className="row fullWidth sub-entity-block-section">
        <div className="large-12 medium-12 small-12 columns header-block">
          <div className="header-text" title={title}>
            {this.replaceOverlapSubEntityChartHeader()} {graphData.scSubEntity.groups[0]}
          </div>
          <span className="sc-category-filter-ico">
            <img
              className="sc-icon-img-cp-wp"
              src={filterIconActive}
              alt="filter"
              onClick={() =>
                this.setState({
                  showFilterSearch: !this.state.showFilterSearch,
                })
              }
            />
            {this.state.showFilterSearch && (
              <FilterSearchComponent
                searchFilterFn={this.searchFilterFn}
                applyFilterFn={this.applyFilterFn}
                selectedFilter={this.state.subCategories}
                closeFilterBox={this.closeFilterBox}
                additionalStyles={{ right: '0' }}
              />
            )}
          </span>
        </div>
        <div className="large-12 medium-12 small-12 columns" style={{ paddingBottom: '1%' }}>
          <div className="sc-category-filter-display">
            {this.state.subCategories.length > 0 &&
              this.state.subCategories.map(selFilter => (<span
                className="category-filter-item overflow-i"
                key={selFilter.value}
              >
                <img
                  className="sc-icon-img-cp-wp"
                  src={clearIcon}
                  alt="Remove"
                  onClick={() => {
                    this.removeFilterFn(selFilter.value);
                  }}
                />
                {selFilter.label}
              </span>
              )
              )}
          </div>
          {subEntities.length > 0 ?
            _.take(subEntities, this.state.displayBarChartCount).map((subEntity, index) => {
              return (
                <BarChart
                  index={index}
                  background={getColorCodeForGivenCategory('SUBENTITY')}
                  width={`${this.findBarWidth(highestWeighted, subEntity.details[0].weighted)}%`}
                  data={subEntity}
                  toolTipContent={() => {
                    return this.getToolTip(subEntity);
                  }}
                />
              );
            }) : <div className="text-align-center margin-top-10">
              <p>{NO_DATA_AVAILABLE_MSG}</p>
            </div>}
        </div>
        {(subEntities.length > this.state.displayBarChartCount) && <div className="large-12 medium-12 small-12 columns margin-bottom-5">
          <button type="button" className="sub-entity-more-button" onClick={this.increaseDisplayBarChartCount}>
            More
          </button>
        </div>
        }
        <div className="padding-10">
          <SalesCatalystSectionBottom />
        </div>
      </div>
    );
  }
}

SalesCatalystSubEntityBarChart.propTypes = {
  graphData: PropTypes.shape({}),
  targetOnScreen: PropTypes.bool,
  getSubEntityBarChartData: PropTypes.func,
  dataOnScreenTarget: PropTypes.shape({}),
  subEntities: PropTypes.instanceOf(Array),
  title: PropTypes.string,
  highestWeighted: PropTypes.number,
  getfilterSearchResult: PropTypes.func,
  componentInfo: PropTypes.shape({
    category: PropTypes.string,
  }),
};

function mapStateToProps(state) {
  let highestWeighted = 0;
  if (typeof state.salesCatalyst.graphData.scSubEntity.subEntities !== 'undefined') {
    highestWeighted = _.maxBy(state.salesCatalyst.graphData.scSubEntity.subEntities,
      subEntity => {
        return subEntity.details[0].weighted;
      }).details[0].weighted;
  }
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    studyFamilyId: typeof state.study.salesCatalystStudy !== 'undefined' &&
    typeof state.study.salesCatalystStudy.studyFamilyId !== 'undefined' ?
    state.study.salesCatalystStudy.studyFamilyId : -1,
    dataSelection: state.salesCatalyst.dataSelection,
    targetOnScreen: state.salesCatalyst.dataOnScreen.targetMarket,
    graphData: state.salesCatalyst.graphData,
    subEntities: typeof state.salesCatalyst.graphData.scSubEntity.subEntities !== 'undefined' ?
      state.salesCatalyst.graphData.scSubEntity.subEntities : [],
    highestWeighted,
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const getSubEntityBarChartData = (report, vpctFilter, top, minSampleSize, subCategories) => {
    const productNo = stateProps.productNo;
    const token = stateProps.loginResponse.data.token;
    const uid = stateProps.loginResponse.data.uid;
    const accountId = stateProps.activeAccountId;
    const reportName = report;
    const targetLabel = stateProps.dataSelection.targetMarket[0].label;
    const targetExpression = stateProps.dataSelection.targetMarket[0].expression;
    const entityLabel = stateProps.dataSelection.entity[0].label;
    const entityExpression = stateProps.dataSelection.entity[0].expression;
    const brandLabel = stateProps.dataSelection.brand.length !== 0 ?
      stateProps.dataSelection.brand[0].label : '';
    const brandExpression = stateProps.dataSelection.brand.length !== 0 ?
      stateProps.dataSelection.brand[0].expression : '';
    const chartType = SC_SUB_ENTITY_REPORT;
    const sortBy = 'pct';
    dispatch(salesCatalystActions.getBarChartReport({
      uid,
      accountId,
      token,
      reportName,
      productNo,
      targetLabel,
      targetExpression,
      entityLabel,
      entityExpression,
      brandLabel,
      brandExpression,
      vpctFilter,
      top,
      minSampleSize,
      chartType,
      sortBy,
      subCategories,
    }));
  };

  const saveSelectedFilters = (value, key) => {
    dispatch(salesCatalystActions.saveTargetFilterData(value, key));
  };

  return Object.assign({}, stateProps, ownProps, {
    getSubEntityBarChartData,
    saveSelectedFilters,
  });
};
export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(SalesCatalystSubEntityBarChart);
